import { render, staticRenderFns } from "./WebsiteVersionsAdmin.vue?vue&type=template&id=bd944b2e&scoped=true"
import script from "./WebsiteVersionsAdmin.vue?vue&type=script&lang=js"
export * from "./WebsiteVersionsAdmin.vue?vue&type=script&lang=js"
import style0 from "./WebsiteVersionsAdmin.vue?vue&type=style&index=0&id=bd944b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd944b2e",
  null
  
)

export default component.exports